
<v-select
    v-model    = "selected"
    :items     = "items"
    :label     = "label"
    :readonly  = "readonly"
    :disabled  = "readonly"
    :background-color = "background"
    item-value = "id"
    item-text  = "name"
    @change    = "onChange"
    :menu-props="{ maxHeight: 600 }"
    :hide-details = "hideDetails"
    class="pr-0"
>
    <template v-slot:item="data">
        <v-hover v-slot="{ hover } " open-delay="0">
            <div
                class="status-item v-flex"
                :class="hover ? 'white--text' : ''"
            >
                <v-icon
                    class = "status-icon"
                    :color= "hover ? 'white' : ''"
                >
                    {{ data.item.font }} {{ 'fa-' + data.item.symbol}}
                </v-icon>
                <div class="status-name">{{data.item.name}}</div>
            </div>
        </v-hover>
    </template>
</v-select>
